/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react'
import { Outlet, Link } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../_metronic/helpers'

const AuthLayout = () => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768)

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768)
    }
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <div
      style={{
        backgroundImage: `url(${toAbsoluteUrl(
          '/media/misc/background_login_page.png'
        )})`,
        // backgroundSize: '50% 100%',
        backgroundSize: isSmallScreen ? '100% 100%' : '50% 100%',
        backgroundRepeat: 'no-repeat',
        backgroundBlendMode: 'normal',
      }}
      className='d-flex flex-column flex-lg-row flex-column-fluid h-100'
    >
      {/* begin::Aside */}
      <div className='d-flex flex-lg-row-fluid col col-lg-8 bgi-size-cover bgi-position-center order-2 order-lg-1'>
        {/* <div className='position-absolute top-0 start-0 p-10'>
          <span className='text-white me-3'>Vous n'avez pas de compte ?</span>
          <button
            style={{
              backgroundColor: 'transparent',
              color: 'white',
              border: '1px solid white',
              borderRadius: '999px',
              marginLeft: '10px',
              padding: '5px 15px',
              cursor: 'pointer',
              fontWeight: '400',
            }}
            className='btn'
          >
            s'inscrire
          </button>
        </div> */}
        {/* begin::Content */}
        <div className='d-flex flex-column flex-center py-15 px-5 px-md-15 w-100'>
          {/* begin::Title */}
          <h1
            style={{
              fontStretch: 'expanded',
              fontSize: '2.8em',
            }}
            className='text-white fw-bolder text-center mb-3'
          >
            Bienvenue !
          </h1>
          {/* end::Title */}

          {/* begin::Text */}
          <div className='text-white fs-base text-center'>
            Bienvenue sur NEXO, votre solution CRM commerciale pour <br /> suivre et maximiser
            vos gains d'entreprise. Gérez vos services, <br /> avec facilité.
          </div>
          {/* end::Text */}
        </div>
        {/* end::Content */}
      </div>
      {/* end::Aside */}
      {/* begin::Body */}
      <div
        style={{
          backgroundColor: 'white',
          // borderTopLeftRadius: '100px',
          // borderBottomLeftRadius: '100px',
          boxShadow: '-5px 0 15px rgba(0, 0, 0, 0.25)',
          ...(isSmallScreen ? {} : { borderTopLeftRadius: '100px', borderBottomLeftRadius: '100px' }),
        }}
        className='d-flex flex-column flex-lg-row-fluid col col-lg-10 p-10 order-1 order-lg-2'
      >
        {/* begin::Form */}
        <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
          {/* begin::Wrapper */}
          <div className='w-100 p-10'>
            <Outlet />
            {/* begin::Divider */}
            {/* <div className='d-flex flex-column flex-center py-5'>
              <div className='d-flex flex-row justify-content-center align-items-center'>
                <span className='text-muted fw-semibold fs-7 mb-2 me-5'>
                  -------------------------------------------------
                </span>
                <span className='text-dark fw-bold fs-3 mb-2'>S'inscrire avec</span>
                <span className='text-muted fw-bold fs-7 mb-2 ms-5'>
                  -------------------------------------------------
                </span>
              </div>

              <div className='d-flex flex-row flex-center'>
                <Link to='#' className='btn btn-icon btn-primary-light btn-circle me-3'>
                  <img src={toAbsoluteUrl('/media/icons/social/facebook.svg')} alt='Facebook' />
                </Link>
                <Link to='#' className='btn btn-icon btn-light btn-circle'>
                  <img src={toAbsoluteUrl('/media/icons/social/gmail.svg')} alt='Gmail' />
                </Link>
              </div>
            </div> */}
            {/* end::Divider */}
          </div>
          {/* end::Wrapper */}
        </div>
        {/* end::Form */}

        {/* begin::Footer */}
        <div className='d-flex flex-center flex-wrap px-5'>
          {/* begin::Links */}
          {/* <div className='d-flex fw-semibold text-primary fs-base'>
            <a href='#' className='px-5' target='_blank'>
              Conditions
            </a>
  
            <a href='#' className='px-5' target='_blank'>
              Plans
            </a>
  
            <a href='#' className='px-5' target='_blank'>
              Contactez-nous
            </a>
          </div> */}
          {/* end::Links */}
        </div>
        {/* end::Footer */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export { AuthLayout }
